export class StringService {
  static trimStringIfToLong(
    text: string,
    maxLength: number,
    addDots = true
  ): string {
    if (!text) return "";
    const dots = addDots ? "…" : "";

    return text.length > maxLength ? text.substr(0, maxLength) + dots : text;
  }

  public static trimFileNameWithExtension(
    fileName: string,
    maxLength: number
  ): string {
    if (fileName.length <= maxLength) {
      return fileName;
    }

    const lastDotIndex = fileName.lastIndexOf(".");
    if (lastDotIndex === -1) {
      // No extension found, use regular trim
      return this.trimStringIfToLong(fileName, maxLength);
    }

    const extension = fileName.substring(lastDotIndex);
    const nameWithoutExtension = fileName.substring(0, lastDotIndex);

    // Account for the "....." and extension in the max length
    const availableLength = maxLength - 5 - extension.length;
    if (availableLength <= 0) {
      // If max length is too small, just return truncated string with extension
      return fileName.substring(0, maxLength - 3) + "...";
    }

    return (
      nameWithoutExtension.substring(0, availableLength) + "....." + extension
    );
  }
}